import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import { api } from '@/utils/api';
import { isBRServer } from '@/utils/Validators/validation';
import logger from '@/utils/logger';
import { GATOR_BACKUP_BUY_FAST_CHECKOUT, GATOR_BACKUP_SSO_URL } from '@/config/api';
import gatorBackupActions from './gatorBackup.actions';
import { GatorBackupActionTypes } from './gatorBackup.types';

export function* buyGatorBackup({ payload }) {
  const { token } = yield select(state => state.auth);

  yield put(gatorBackupActions.loading(true));

  try {
    const request = {
      url: GATOR_BACKUP_BUY_FAST_CHECKOUT,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: { ...payload },
    };

    const response = yield call(api.whmcs.post, request);
    const invoiceId = response && response.data && response.data.data && response.data.data.invoice_id;

    yield put(gatorBackupActions.buy.success({ invoiceId }));
  } catch (requestError) {
    const error = { ...requestError, userRequestData: payload };
    logger.error('Error sagas gatorBackup - method buyGatorBackup', error);
    yield put(gatorBackupActions.buy.failure());
  } finally {
    yield put(gatorBackupActions.loading(false));
  }
}

function* getGatorBackupSso({ payload }) {
  const { hostingId } = payload;
  const { token, jwt: jwtToken } = yield select(state => state.auth);
  const brand = isBRServer ? 'br' : 'es';

  const request = {
    url: GATOR_BACKUP_SSO_URL(hostingId),
    headers: {
      Authorization: `Bearer ${token}`,
      'x-service-token': jwtToken,
      brand,
    },
  };

  try {
    const response = yield call(api.whmcs.get, request);
    const url = response?.data?.url;
    yield put(gatorBackupActions.ssoSuccess(url));
    window.open(url, '_blank');
  } catch (e) {
    const error = { ...e, userRequestData: request };
    logger.error('Error sagas getGatorBackupSso', error);
    yield put(gatorBackupActions.ssoFailure(e?.message || 'Erro ao acessar o painel'));
  }
}

function* gatorBackupSagas() {
  yield takeLatest(GatorBackupActionTypes.GATOR_BACKUP_BUY_REQUEST, buyGatorBackup);
  yield takeLatest(GatorBackupActionTypes.SSO_REQUEST, getGatorBackupSso);
}

export default gatorBackupSagas;
